import React from 'react';
import { Link } from 'react-router-dom';

export const faqAccount = [
  {
    id: 0,
    title: 'Come posso modificare il mio username?',
    description: (
      <p className="mb-0">
        Facile! Vai su <Link to="/account">Impostazioni</Link>, nella sezione{' '}
        <strong>Profilo</strong>.
      </p>
    )
  },
  {
    id: 1,
    title: 'Come posso modificare la mia email?',
    description: (
      <p className="mb-0">
        Ops, al momento non puoi farlo direttamente dall'app. Mandaci una mail a{' '}
        <a href="mailto:info@fantaclasse.i">info@fantaclasse.it</a> e lo faremo
        noi per te! 😉
      </p>
    )
  },
  {
    id: 2,
    title:
      'Basta! Perdo sempre al FantaClasse e voglio eliminare il mio account!',
    description: (
      <p className="mb-0">
        Ehi, aspetta un attimo campione! 🏆 Prima di gettare la spugna, ricorda
        che anche Ronaldo ha avuto i suoi momenti no. Ma se proprio vuoi dire
        addio, vai su <Link to="/account">Impostazioni</Link> e cerca{' '}
        <strong>"Elimina Account"</strong>. Però occhio: una volta fatto, puff!
        💨 Sparisce tutto.
      </p>
    )
  },
  {
    id: 3,
    title: 'Come posso cambiare la mia password?',
    description: (
      <p className="mb-0">
        Per cambiare la tua password, vai alla pagina delle{' '}
        <Link to="/account">Impostazioni</Link> e seleziona l'opzione{' '}
        <strong>"Modifica Password"</strong>. Dovrai inserire la tua password
        attuale e poi la nuova password due volte per conferma.
      </p>
    )
  },
  {
    id: 4,
    title: 'Posso avere più di un account?',
    description: (
      <p className="mb-0">
        Nope! <strong>Un solo account per studente</strong>.
      </p>
    )
  }
];

export const faqClasse = [
  {
    id: 0,
    title: "Cos'è il Codice Classe?",
    description: (
      <p className="mb-0">
        Il Codice Classe è un <strong>codice unico</strong> assegnato a ogni
        classe creata su FantaClasse. Viene utilizzato per invitare altri utenti
        a unirsi alla tua classe.
      </p>
    )
  },
  {
    id: 1,
    title: 'Come invito i miei compagni ad entrare nella mia classe?',
    description: (
      <p className="mb-0">
        Per invitare i tuoi compagni, condividi con loro il{' '}
        <strong>Codice Classe</strong>. Possono inserirlo nella sezione{' '}
        <strong>"Unisciti a una Classe"</strong> e... tadaaa! Via alla
        competizione!
      </p>
    )
  },
  {
    id: 2,
    title: 'Come posso eleggere nuovi Capo Classe?',
    description: (
      <p className="mb-0">
        Solo il <strong>Capo Classe attuale</strong> può assegnare il ruolo a un
        altro membro. Il Capo Classe può farlo dalla sezione{' '}
        <strong>"Gestione Classe"</strong> dalla pagina{' '}
        <Link to="/classe">Classe</Link>.
      </p>
    )
  },
  {
    id: 3,
    title: 'Come posso rimuovere un utente dalla classe?',
    description: (
      <p className="mb-0">
        Solo il <strong>Capo Classe</strong> può rimuovere utenti. Dalla sezione{' '}
        <strong>"Gestione Classe"</strong>, seleziona il nome dell'utente e
        scegli l'opzione <strong>"Rimuovi dalla Classe"</strong>. È come avere
        il potere di espellere qualcuno... ma senza urlare "Vadaaaaa
        fuoriiiiii!" 🚪🏃
      </p>
    )
  },
  {
    id: 4,
    title:
      "C'è un limite al numero di studenti che possono essere in una classe?",
    description: (
      <p className="mb-0">
        Tecnicamente no, ma immagina di avere una festa con 100 persone in una
        stanza piccola. Caos totale! 🎉 Consigliamo di stare sui{' '}
        <strong>30-40 studenti</strong> per non trasformare la classe in un
        concerto rock.
      </p>
    )
  },
  {
    id: 5,
    title: 'Posso essere in più di una classe contemporaneamente?',
    description: (
      <p className="mb-0">
        Nah, sei mica Harry Potter con la Giratempo! 🧙‍♂️⏳{' '}
        <strong>Una classe alla volta</strong>, altrimenti rischi di incontrare
        te stesso nei corridoi.
      </p>
    )
  },
  {
    id: 6,
    title: 'Come posso uscire da una classe?',
    description: (
      <p className="mb-0">
        Per abbandonare la tua classe, vai su{' '}
        <Link to="/account">Impostazioni</Link> nel tuo account e seleziona
        l'opzione <strong>Esci dalla classe</strong>. Se sei il capoclasse, ti
        consigliamo di eleggere un nuovo capoclasse prima di uscire. Ricorda che
        una volta uscito dalla classe,{' '}
        <strong>perderai tutti i tuoi progressi</strong>.
      </p>
    )
  },
  {
    id: 7,
    title: 'Come posso eliminare una classe?',
    description: (
      <p className="mb-0">
        Per eliminare una classe, è necessario che{' '}
        <strong>non rimangano più utenti</strong> all'interno. Se sei il
        capoclasse, rimuovi tutti i membri uno per uno e infine esci anche tu.
        La classe verrà eliminata automaticamente quando l'ultimo utente esce.
      </p>
    )
  }
];

export const faqBonusMalus = [
  {
    id: 0,
    title: 'Come posso aggiungere Bonus o Malus a un giocatore?',
    description: (
      <p className="mb-0">
        Se sei il <strong>Capo Classe</strong>, hai il potere supremo! ⚡ Vai
        sul <strong>profilo del giocatore</strong>, scegli Bonus o Malus e...
        zap! Punti assegnati come per magia.
      </p>
    )
  },
  {
    id: 1,
    title:
      'Come posso eliminare un Bonus o un Malus aggiunto a un giocatore per errore?',
    description: (
      <p className="mb-0">
        Oops! 🙊 Per ora non si può cancellare, ma stiamo lavorando per darti il
        potere di correggere eventuali errori. Nel frattempo, puoi{' '}
        <strong>compensare con un Bonus/Malus opposto</strong>. È come in
        matematica: + e - si annullano!
      </p>
    )
  },
  {
    id: 2,
    title: 'Posso creare dei Bonus o Malus personalizzati per la mia classe?',
    description: (
      <p className="mb-0">
        Sì, il <strong>Capo Classe</strong> può creare Bonus o Malus
        personalizzati dalla pagina di aggiunta dei Bonus o Malus di un
        giocatore. Puoi definire il <strong>nome</strong>, il{' '}
        <strong>valore in punti</strong> e se è applicabile a{' '}
        <strong>Professori, Studenti o entrambi</strong>.
      </p>
    )
  },
  {
    id: 3,
    title:
      'Come vengono calcolati i punteggi finali considerando Bonus e Malus?',
    description: (
      <p className="mb-0">
        I punteggi finali sono la{' '}
        <strong>somma di tutti i Bonus e Malus</strong> assegnati a ciascun
        giocatore durante il periodo di gioco. Questi punti si sommano ai
        punteggi base dei membri della squadra.
      </p>
    )
  }
];

export const faqProfessoriStudenti = [
  {
    id: 0,
    title: 'Come aggiungo professori e studenti?',
    description: (
      <p className="mb-0">
        Il <strong>Capo Classe</strong> può aggiungere professori e studenti
        dalla pagina <Link to="/account">Classe</Link>. Basta premere sull'icona
        apposita.
      </p>
    )
  },
  {
    id: 1,
    title: 'Cosa succede se elimino un professore o uno studente?',
    description: (
      <p className="mb-0">
        Se elimini un professore o uno studente, verranno{' '}
        <strong>rimossi dalla classe e da tutte le squadre</strong> in cui sono
        presenti. I punteggi delle squadre resteranno invariati.
      </p>
    )
  },
  {
    id: 2,
    title: 'Perché non funziona il grafico sulla pagina del giocatore?',
    description: (
      <p className="mb-0">
        I grafici sono attualmente <strong>in fase di sviluppo</strong>.
        Verranno resi operativi nelle prossime settimane.
      </p>
    )
  },
  {
    id: 3,
    title:
      'Posso modificare le informazioni di un professore o studente dopo averli aggiunti?',
    description: (
      <p className="mb-0">
        Sì, il Capo Classe può modificare le{' '}
        <strong>informazioni di base</strong> come nome e prezzo attraverso la
        pagina del singolo giocatore. Tuttavia, alcuni dati come i punteggi non
        possono essere modificati direttamente.
      </p>
    )
  }
];

export const faqSquadre = [
  {
    id: 0,
    title: 'Come creo la mia squadra? Quanti docenti? Quanti studenti?',
    description: (
      <p className="mb-0">
        Per creare la tua squadra, vai nella pagina{' '}
        <Link to="/team">Squadra</Link>. Ogni squadra deve essere composta da{' '}
        <strong>1 professore e 4 studenti</strong>. Scegli il nome e la
        descrizione della tua squadra e seleziona i membri dalla lista
        disponibile nella tua classe.
      </p>
    )
  },
  {
    id: 1,
    title: 'La mia squadra non mi piace più, voglio cambiarla!',
    description: (
      <p className="mb-0">
        Una volta creata,{' '}
        <strong>
          non è possibile modificare la composizione della squadra
        </strong>{' '}
        durante la stagione in corso. Se desideri fortemente un cambiamento,
        puoi{' '}
        <strong>
          eliminare completamente la squadra attuale e crearne una nuova
        </strong>
        , ma perderai tutti i punti accumulati fino a quel momento. Valuta
        attentamente questa opzione!
      </p>
    )
  },
  {
    id: 2,
    title: 'Come posso eliminare la mia squadra?',
    description: (
      <p className="mb-0">
        Per eliminare la tua squadra, vai su{' '}
        <Link to="/account">Impostazioni</Link> e troverai l'opzione{' '}
        <strong>"Elimina Squadra"</strong>. Conferma l'eliminazione quando
        richiesto. Attenzione: questa azione è definitiva e comporterà la{' '}
        <strong>perdita di tutti i punti accumulati</strong>.
      </p>
    )
  },
  {
    id: 3,
    title: 'Posso avere più di una squadra?',
    description: (
      <p className="mb-0">
        Nope! <strong>Una squadra per giocatore</strong>.
      </p>
    )
  },
  {
    id: 4,
    title: 'Come viene calcolato il punteggio di una squadra?',
    description: (
      <p className="mb-0">
        Il punteggio della squadra è la{' '}
        <strong>somma dei punteggi individuali</strong> dei suoi membri (1
        professore e 4 studenti) a partire da quando viene creata la squadra.
      </p>
    )
  }
];

export const faqGameplay = [
  {
    id: 0,
    title: 'Come funziona la classifica?',
    description: (
      <p className="mb-0">
        La <Link to="/ranking">Classifica</Link> è basata sui{' '}
        <strong>punteggi totali delle squadre</strong>. Le squadre con i
        punteggi più alti sono in cima alla classifica. La classifica viene{' '}
        <strong>aggiornata in tempo reale</strong> man mano che vengono
        assegnati Bonus e Malus.
      </p>
    )
  },
  {
    id: 1,
    title: 'Ci sono premi per le squadre migliori?',
    description: (
      <p className="mb-0">
        I premi dovete deciderli voi! Potrebbero essere{' '}
        <strong>
          premi simbolici, riconoscimenti in classe, o altri riconoscimenti
        </strong>{' '}
        decisi dalla vostra scuola o classe.
      </p>
    )
  },
  {
    id: 2,
    title: 'Quanto dura una "stagione" di gioco?',
    description: (
      <p className="mb-0">
        La durata di una stagione di gioco è generalmente{' '}
        <strong>allineata con l'anno scolastico</strong>, ma potete decidere sia
        di iniziare più tardi, sia di terminare prima e ricominciare eliminando
        la classe.
      </p>
    )
  },
  {
    id: 3,
    title: 'Come posso vedere i progressi della mia squadra nel tempo?',
    description: (
      <p className="mb-0">
        Nella pagina della tua <Link to="/team">Squadra</Link>, troverai, dalle
        prossime versioni, un{' '}
        <strong>grafico che mostra l'andamento dei punteggi nel tempo</strong>.
        Puoi anche vedere i contributi individuali di ciascun membro della
        squadra.
      </p>
    )
  }
];
